import { render, staticRenderFns } from "./IconCountList.vue?vue&type=template&id=96badfe2&scoped=true&"
import script from "./IconCountList.vue?vue&type=script&lang=js&"
export * from "./IconCountList.vue?vue&type=script&lang=js&"
import style0 from "./IconCountList.vue?vue&type=style&index=0&id=96badfe2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96badfe2",
  null
  
)

export default component.exports